import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2073ParamStatus: 'idle',
    startProcess2073ParamError: undefined as any,
    loadUserParamsProcess2073ParamStatus: 'idle',
    loadUserParamsProcess2073ParamError: undefined as any,

    process2073ParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2073Param = createAsyncThunk('process2073ParamSlice/startProcess2073Param', async ({ process2073Param }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2073Param/`,
        prepareData(process2073Param),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2073ParamStatus } = getState().process2073ParamSlice
        return startProcess2073ParamStatus !== 'pending'
    }
})

export const loadUserParamsProcess2073Param = createAsyncThunk('process2073ParamSlice/loadUserParamsProcess2073Param', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2073Param/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2073ParamStatus } = getState().process2073ParamSlice
        return loadUserParamsProcess2073ParamStatus !== 'pending'
    }
})

const Process2073ParamSlice = createSlice({
    name: 'process2073ParamSlice',
    initialState,
    reducers: {
        resetstartProcess2073Param: (state) => {
            state.job = undefined
            state.startProcess2073ParamError = undefined
        },
        resetstartProcess2073ParamError: (state) => {
            state.startProcess2073ParamError = undefined
        },
        resetloadUserParamsProcess2073Param: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2073ParamError = undefined
        },
        resetloadUserParamsProcess2073ParamError: (state) => {
            state.loadUserParamsProcess2073ParamError = undefined
        },
        removeFromProcess2073ParamListById: (state, action) => {
            state.process2073ParamList = state.process2073ParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2073ParamListByIds: (state, action) => {
            state.process2073ParamList = state.process2073ParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2073ParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2073ParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2073ParamList = []
            state.startProcess2073ParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2073Param.pending, (state) => {
            state.startProcess2073ParamStatus = 'pending'
            state.startProcess2073ParamError = undefined
        })
        builder.addCase(startProcess2073Param.fulfilled, (state, action) => {
            state.startProcess2073ParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2073Param.rejected, (state, action) => {
            state.startProcess2073ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2073ParamError = action.error.message
            } else {
                state.startProcess2073ParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2073Param.pending, (state) => {
            state.loadUserParamsProcess2073ParamStatus = 'pending'
            state.loadUserParamsProcess2073ParamError = undefined
        })
        builder.addCase(loadUserParamsProcess2073Param.fulfilled, (state, action) => {
            state.loadUserParamsProcess2073ParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2073Param.rejected, (state, action) => {
            state.loadUserParamsProcess2073ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2073ParamError = action.error.message
            } else {
                state.loadUserParamsProcess2073ParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2073Param,
    resetstartProcess2073ParamError,
    resetloadUserParamsProcess2073Param,
    resetloadUserParamsProcess2073ParamError,
    removeFromProcess2073ParamListById,
    removeFromProcess2073ParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2073ParamSlice.actions
export default Process2073ParamSlice.reducer
